// import ProductCard from "../Tatpurush/Product/productCard";
// import UserLogin from "../Tatpurush/Login/userLogin";
// import UserRegister from "../Tatpurush/Login/userRegister";
// import ScrollImages from "../Tatpurush/webSite/ScrollImages";
// import AboutUs from "../Tatpurush/webSite/AboutUs";
// import Vision from "../Tatpurush/webSite/Vision";
// import Legals from "../Tatpurush/webSite/Legals";
// import Terms from "../Tatpurush/webSite/Terms";
// import NewRegister from "../Tatpurush/Login/newRegister";
// import Cart from "../Tatpurush/Cart/Cart";
// import Contact from "../Tatpurush/webSite/Contact";
// import ProductDetail from "../Tatpurush/Product/productDetail";

import About from "../components/About";
import Contact from "../components/Contact";
import DashBoard from "../components/dashbaord";
import Blogs from "../components/Home/blogs";
import Home from "../components/Home/home";
import Product from "../components/Product/index";
import QuoteModal from "../components/Quote/quoteModal";
import RequestInformationForm from "../components/Quote/requestInformationForm";

const publicRoutes = [
  {
    path: "/",
    component: <DashBoard />,
    children: [
      {
        index: true, // Default route at /dashboard
        element: <Home />,
      },
      {
        path: "product",
        element: <Product id={1} title={"product"} />,
      },
      {
        path: "parlour-on-wheels",
        element: <Product id={2} title={"parlour on wheels"} />,
      },
      {
        path: "tricycle-carts",
        element: <Product id={3} title={"Tricyle Carts/ Push Cart"} />,
      },
      {
        path: "e-carts",
        element: <Product id={4} title={"E-carts / E Rcikshaw"} />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "blogs",
        element: <Blogs />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "quote",
        element: <QuoteModal />,
      },
      {
        path: "information",
        element: <RequestInformationForm />,
      },
    ],
  },

  // {
  //   path: "/user",
  //   component: <UserLogin />,
  // },
  // {
  //   path: "/user/register/:acc_id",
  //   component: <UserRegister />,
  // },
  // {
  //   path: "/user/register",
  //   component: <UserRegister />,
  // },
  // {
  //   path: "/user/register/details",
  //   component: <NewRegister />,
  // },
];

export { publicRoutes };
